// ─── src/hooks/useMeetupFeedbacks.ts ─────────────────────────────────────────

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteMeetupFeedback,
  getMeetupFeedbacks,
  getMeetupFeedbackStats,
} from "../api/meetupFeedbacks";

export const meetupFeedbackKeys = {
  all: ["meetupFeedbacks"] as const,
  list: (eventId?: string) =>
    [...meetupFeedbackKeys.all, "list", eventId ?? "all"] as const,
  stats: (eventId?: string) =>
    [...meetupFeedbackKeys.all, "stats", eventId ?? "all"] as const,
};

export const useMeetupFeedbacks = (eventId?: string) =>
  useQuery({
    queryKey: meetupFeedbackKeys.list(eventId),
    queryFn: () => getMeetupFeedbacks(eventId),
    staleTime: 30_000,
  });

export const useMeetupFeedbackStats = (eventId?: string) =>
  useQuery({
    queryKey: meetupFeedbackKeys.stats(eventId),
    queryFn: () => getMeetupFeedbackStats(eventId),
    staleTime: 60_000,
  });

export const useDeleteMeetupFeedback = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteMeetupFeedback,
    onSuccess: () => qc.invalidateQueries({ queryKey: meetupFeedbackKeys.all }),
  });
};
